import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material';

import { RnplCommonModule, UIComponentsModule } from 'common/src/modules';
import { DownloadTemplateComponent } from './download-template.component';
import { DataImportApiService } from '../../data-import-api.service';


@NgModule({
  declarations: [
    DownloadTemplateComponent
  ],
  exports: [
    DownloadTemplateComponent
  ],
  imports: [
    CommonModule,
    UIComponentsModule,
    RnplCommonModule,
    TranslateModule,
  ],
  providers: [
    DataImportApiService,
    {
      provide: MatDialogRef,
      useValue: {}
    },
  ],
})
export class DownloadTemplateModule { }
